var $a61375bbb065e4f1$exports = {};
(function() {
    const task = getTaskID();
    if (task) {
        console.log(`Jira taskId: ${task}`);
        console.log(`URL: https://pixrig.atlassian.net/browse/${task}`);
        console.log('Hash commit: ', "1d487b8ab680ef549ecef795bf47ff6ad0bfaee0");
    }
    function getTaskID() {
        const commitMessage = undefined;
        if (commitMessage) {
            const taskID = commitMessage.match(/EN-\d+/);
            if (taskID) return taskID[0];
        }
        return null;
    }
})();


//# sourceMappingURL=storibox.0157a1b8.js.map
